import * as React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import Modal from './modal';
import Alert, { AlertCategoryEnum } from './Alert';
import { SelectableFixedComment } from '../../PulmonaryFunctionTests/Shared/UseFixedComments';

export interface CommentsDialogProps {
    header: string;
    show: boolean;
    editable?: boolean;
    errorMessage?: string;
    items: Array<SelectableFixedComment>;
    showFilter?: boolean;
    onChange: (id: string, checked: boolean) => void;
    onClose: () => void;
}

export interface CommentsSelectorProps {
    onOk: () => void;
    editable?: boolean;
    errorMessage?: string;
    showFilter?: boolean;
    items: Array<SelectableFixedComment>;
    onChange: (id: string, checked: boolean) => void;
}

export const CommentsDialog = (props: CommentsDialogProps) => {
    const { header, show, onClose } = props;

    return (
        <Modal show={show} header={header} closeModalHandler={() => onClose()}>
            <CommentsSelector {...props} onOk={() => onClose()} />
        </Modal>
    );
}

export const CommentsSelector = ({ onOk, items, onChange, errorMessage = null, editable = true, showFilter = false }: CommentsSelectorProps) => {
    const [filterText, setFilterText] = React.useState();

    const onTextFilter = (event) => {
        setFilterText(event.target.value.toLowerCase());
    }

    const filteredItems = items.filter(i => filterText === undefined || i.comment.toLowerCase().includes(filterText));

    const hideFixedComment = (fixedComment: SelectableFixedComment): boolean => {
        return fixedComment.disabled || !fixedComment.selected || !fixedComment.followOnCommentAvailable;
    };

    const renderItems = () => {
        if (filteredItems.length > 0) {
            return filteredItems.sort((a, b) => a.displayOrder - b.displayOrder).map(i => {
                const tooltip = i.description ? <Tooltip id="descriptionTooltip" style={{ zIndex: 2500 }}>
                    {i.description}
                </Tooltip> : <></>;

                return (
                    <React.Fragment key={i.id}>
                        <OverlayTrigger placement="top" overlay={tooltip} animation={null}>
                            <div className="checkbox">
                                <label htmlFor={i.id}>
                                    <input id={i.id} type="checkbox" disabled={!editable} checked={i.selected} onChange={(e) => onChange(e.target.id, e.target.checked)} />
                                    {i.comment}
                                </label>
                            </div>
                        </OverlayTrigger>
                        <div hidden={hideFixedComment(i)}>
                            <label htmlFor={`comment-annotation-${i.id}`}>{i.followOnCommentAnnotation}</label>
                            <input className="form-control" id={`comment-annotation-${i.id}`} disabled={!editable} checked={i.selected} onChange={(e) => onChange(e.target.id, e.target.checked)} />
                        </div>
                    </React.Fragment>
                );
            })
        } else {
            return (
                <Alert show={true} category={AlertCategoryEnum.Danger}>
                    There are no fixed comments available
                </Alert>
            );
        }
    }

    return (
        <>
            <div className="modal-body">
                <Alert show={errorMessage !== null} category={AlertCategoryEnum.Danger}>
                    {errorMessage}
                </Alert>
                {showFilter ? <div className="form-group">
                    <input type="text" className="form-control" placeholder="Filter..." onChange={onTextFilter} />
                </div> : null}
                {renderItems()}
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" data-automationid="submit-modal" disabled={errorMessage !== null} onClick={() => onOk()}>OK</button>
            </div>
        </>
    );
}
